import {BillingRegion, PaymentCurrencyType} from "@irati/types"

const PurchaseCurrencies = {
  [PaymentCurrencyType.Gbp]: [BillingRegion.En],
  [PaymentCurrencyType.Aud]: [BillingRegion.Au, BillingRegion.Nz]
}
export const DEFAULT_CURRENCY = PaymentCurrencyType.Gbp
export default PurchaseCurrencies
